import { call } from 'redux-saga/effects'
import { CANCEL } from 'redux-saga'
import { createAction } from 'redux-actions'
import axios from 'axios'

// @ts-ignore
import { offline } from 'store/entities/offline/actions'
// @ts-ignore
import { addToQueueWithWaiting } from 'store/entities/offline/saga/addToQueueWithWaiting'

/**
 * Helper for creating API request actions.
 * Example usage:
 * // actions.js
 * // returns actions userFromAPI.fetch(12), userFromAPI.fetchSuccess(payload: response), userFromAPI.fetchFail(error)
 * const userFromAPI = createRequestActions('USER/FETCH', id => ({
 *   request: {
 *     url: `/users/${id}`,
 *     method: 'GET',
 *   },
 * }))
 *
 * @param actionType - entity name with action (for example: "IDENTITY/FETCH", "IDENTITY/INSERT", "PROTRACKS/FETCH", ...)
 * @param callback func : params => ({
 *          url: string, // string for creating request
 *          method: "GET" | "POST" | "PUT" | "DELETE" | "PATCH",
 *          data?: object,
 *        }) - data for making request
 * @returns { [entity] } = { [entity]: { [entity].[action], [entity].[action]Success, [entity].[action]Fail } }
 */
interface IRequestPayload<D = any> {
  request: {
    data?: D
    method?: string
    url: string
    cancelToken?: any
  }
}

export const createRequestActions = (actionType: string, callback: (params?: any) => IRequestPayload) => {
  const cancelSource = axios.CancelToken.source()
  const requestAction = (params?: any) => offline.request(actionType, callback(params))
  requestAction.toString = () => actionType
  requestAction.call = (params: IRequestPayload) => {
    if (params?.request) {
      params.request.cancelToken = cancelSource.token
    }
    return call(addToQueueWithWaiting, { payload: { actionType, params: callback(params) } })
  }
  requestAction.success = createAction(`${actionType}_SUCCESS`)
  requestAction.fail = createAction(`${actionType}_FAIL`)
  /* this action can be used in order to trigger saga or in case when reducer must know that some data loading process is started  */
  requestAction.startAction = createAction(`${actionType}_START`)
  // @ts-ignore
  requestAction[CANCEL] = () => cancelSource.cancel()
  return requestAction
}

/**
 * Full usage example:
 *
 * import { createRequestActions as request } from 'store/actionCreators'
 *
 * const identity = {}
 * identity.data = request('IDENTITY_DATA/FETCH', id => ({ url: `/user/${id}` }))
 * export identity
 */
